import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="bg-bordo text-crema py-20 px-4 md:px-8" data-id="element-158">
      <div className="max-w-4xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-161">
            La verdad es esta:
          </h2>
          <p className="text-xl md:text-2xl mb-4" data-id="element-162">
            La milanesa no es aburrida.
          </p>
          <p className="text-xl md:text-2xl font-bold text-dorado mb-12" data-id="element-163">
            Aburrido es hacerla siempre de la misma forma.
          </p>

          <p className="text-2xl mb-4" data-id="element-164">Y por eso nace:</p>
          <h3 className="text-4xl md:text-6xl font-serif font-bold text-dorado mb-8" data-id="element-165">
            🥩 La Biblia de la Milanesa
          </h3>
          <p className="text-lg md:text-xl max-w-2xl mx-auto" data-id="element-166">
            Una guía práctica para amantes de las milanesas y para personas que
            quieren resolver comidas rápidas, ricas y sin estrés.
          </p>
        </motion.div>

        <div className="bg-bordo-dark rounded-2xl p-8 md:p-12 shadow-xl mt-16" data-id="element-167">
          <p className="text-xl font-bold mb-6 text-center" data-id="element-168">Pero ojo.</p>
          <p className="text-lg mb-4 text-center" data-id="element-169">
            Esto no es un recetario común.
          </p>
          <p className="text-lg mb-4 text-center" data-id="element-170">
            No es una lista de recetas tiradas una atrás de otra.
          </p>
          <p className="text-lg text-center" data-id="element-171">
            No es un PDF lleno de platos imposibles, ingredientes raros o
            técnicas que nadie usa en una cocina real.
          </p>
        </div>
      </div>
    </section>;
}